import { useLayoutEffect } from 'react';
import { Layout } from '../../components/common/Layout';
import { Home } from '../../components/home/Home';

export const HomePage = () => {
    const title = "Главная";

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "white";
        document.body.style.backgroundImage = "";
    });

    return (
        <Layout title={title}>
            <Home />
        </Layout>
    );
};

